"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _from = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/from"));
require("core-js/modules/es6.array.filter.js");
require("core-js/modules/es6.array.map.js");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _lodash = require("lodash");
var _polished = require("polished");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactDeviceDetect = require("react-device-detect");
var _reactDom = _interopRequireDefault(require("react-dom"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _excluded = ["themeContext"];
var _jsxFileName = "/codebuild/output/src659801953/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/FilmStrip/lib/FilmStrip.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _templateObject9,
  _templateObject10,
  _templateObject11,
  _templateObject12,
  _templateObject13,
  _templateObject14,
  _templateObject15,
  _templateObject16,
  _templateObject17;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_1o978z52du() {
  var path = "/codebuild/output/src659801953/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/FilmStrip/lib/FilmStrip.js";
  var hash = "c9ae74d26da86d487a7586b60d9896b4003a6ae4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src659801953/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/FilmStrip/lib/FilmStrip.js",
    statementMap: {
      "0": {
        start: {
          line: 19,
          column: 26
        },
        end: {
          line: 19,
          column: 42
        }
      },
      "1": {
        start: {
          line: 21,
          column: 16
        },
        end: {
          line: 26,
          column: 1
        }
      },
      "2": {
        start: {
          line: 28,
          column: 24
        },
        end: {
          line: 86,
          column: 1
        }
      },
      "3": {
        start: {
          line: 56,
          column: 6
        },
        end: {
          line: 59,
          column: 7
        }
      },
      "4": {
        start: {
          line: 80,
          column: 8
        },
        end: {
          line: 83,
          column: 9
        }
      },
      "5": {
        start: {
          line: 88,
          column: 15
        },
        end: {
          line: 198,
          column: 1
        }
      },
      "6": {
        start: {
          line: 110,
          column: 8
        },
        end: {
          line: 117,
          column: 9
        }
      },
      "7": {
        start: {
          line: 124,
          column: 48
        },
        end: {
          line: 124,
          column: 68
        }
      },
      "8": {
        start: {
          line: 144,
          column: 8
        },
        end: {
          line: 150,
          column: 9
        }
      },
      "9": {
        start: {
          line: 153,
          column: 8
        },
        end: {
          line: 156,
          column: 9
        }
      },
      "10": {
        start: {
          line: 159,
          column: 8
        },
        end: {
          line: 185,
          column: 9
        }
      },
      "11": {
        start: {
          line: 162,
          column: 12
        },
        end: {
          line: 184,
          column: 13
        }
      },
      "12": {
        start: {
          line: 194,
          column: 10
        },
        end: {
          line: 194,
          column: 57
        }
      },
      "13": {
        start: {
          line: 199,
          column: 23
        },
        end: {
          line: 206,
          column: 1
        }
      },
      "14": {
        start: {
          line: 200,
          column: 2
        },
        end: {
          line: 202,
          column: 3
        }
      },
      "15": {
        start: {
          line: 201,
          column: 4
        },
        end: {
          line: 201,
          column: 22
        }
      },
      "16": {
        start: {
          line: 203,
          column: 22
        },
        end: {
          line: 203,
          column: 47
        }
      },
      "17": {
        start: {
          line: 205,
          column: 2
        },
        end: {
          line: 205,
          column: 82
        }
      },
      "18": {
        start: {
          line: 207,
          column: 16
        },
        end: {
          line: 298,
          column: 1
        }
      },
      "19": {
        start: {
          line: 222,
          column: 30
        },
        end: {
          line: 222,
          column: 63
        }
      },
      "20": {
        start: {
          line: 225,
          column: 8
        },
        end: {
          line: 228,
          column: 3
        }
      },
      "21": {
        start: {
          line: 230,
          column: 24
        },
        end: {
          line: 230,
          column: 53
        }
      },
      "22": {
        start: {
          line: 231,
          column: 23
        },
        end: {
          line: 231,
          column: 51
        }
      },
      "23": {
        start: {
          line: 234,
          column: 24
        },
        end: {
          line: 234,
          column: 87
        }
      },
      "24": {
        start: {
          line: 239,
          column: 10
        },
        end: {
          line: 243,
          column: 19
        }
      },
      "25": {
        start: {
          line: 249,
          column: 25
        },
        end: {
          line: 249,
          column: 106
        }
      },
      "26": {
        start: {
          line: 256,
          column: 30
        },
        end: {
          line: 256,
          column: 63
        }
      },
      "27": {
        start: {
          line: 259,
          column: 8
        },
        end: {
          line: 262,
          column: 7
        }
      },
      "28": {
        start: {
          line: 265,
          column: 22
        },
        end: {
          line: 265,
          column: 52
        }
      },
      "29": {
        start: {
          line: 268,
          column: 24
        },
        end: {
          line: 268,
          column: 87
        }
      },
      "30": {
        start: {
          line: 276,
          column: 93
        },
        end: {
          line: 289,
          column: 9
        }
      },
      "31": {
        start: {
          line: 302,
          column: 22
        },
        end: {
          line: 311,
          column: 3
        }
      },
      "32": {
        start: {
          line: 303,
          column: 4
        },
        end: {
          line: 310,
          column: 5
        }
      },
      "33": {
        start: {
          line: 307,
          column: 8
        },
        end: {
          line: 307,
          column: 56
        }
      },
      "34": {
        start: {
          line: 309,
          column: 8
        },
        end: {
          line: 309,
          column: 39
        }
      },
      "35": {
        start: {
          line: 313,
          column: 22
        },
        end: {
          line: 322,
          column: 3
        }
      },
      "36": {
        start: {
          line: 314,
          column: 4
        },
        end: {
          line: 321,
          column: 5
        }
      },
      "37": {
        start: {
          line: 318,
          column: 8
        },
        end: {
          line: 318,
          column: 23
        }
      },
      "38": {
        start: {
          line: 320,
          column: 8
        },
        end: {
          line: 320,
          column: 24
        }
      },
      "39": {
        start: {
          line: 324,
          column: 2
        },
        end: {
          line: 338,
          column: 4
        }
      },
      "40": {
        start: {
          line: 340,
          column: 0
        },
        end: {
          line: 350,
          column: 2
        }
      },
      "41": {
        start: {
          line: 351,
          column: 0
        },
        end: {
          line: 357,
          column: 2
        }
      },
      "42": {
        start: {
          line: 358,
          column: 20
        },
        end: {
          line: 358,
          column: 63
        }
      },
      "43": {
        start: {
          line: 364,
          column: 21
        },
        end: {
          line: 388,
          column: 3
        }
      },
      "44": {
        start: {
          line: 390,
          column: 24
        },
        end: {
          line: 402,
          column: 3
        }
      },
      "45": {
        start: {
          line: 405,
          column: 4
        },
        end: {
          line: 405,
          column: 17
        }
      },
      "46": {
        start: {
          line: 406,
          column: 4
        },
        end: {
          line: 413,
          column: 6
        }
      },
      "47": {
        start: {
          line: 415,
          column: 4
        },
        end: {
          line: 415,
          column: 45
        }
      },
      "48": {
        start: {
          line: 416,
          column: 4
        },
        end: {
          line: 416,
          column: 37
        }
      },
      "49": {
        start: {
          line: 420,
          column: 4
        },
        end: {
          line: 420,
          column: 77
        }
      },
      "50": {
        start: {
          line: 421,
          column: 4
        },
        end: {
          line: 421,
          column: 33
        }
      },
      "51": {
        start: {
          line: 422,
          column: 4
        },
        end: {
          line: 422,
          column: 26
        }
      },
      "52": {
        start: {
          line: 426,
          column: 4
        },
        end: {
          line: 426,
          column: 33
        }
      },
      "53": {
        start: {
          line: 430,
          column: 4
        },
        end: {
          line: 432,
          column: 5
        }
      },
      "54": {
        start: {
          line: 431,
          column: 6
        },
        end: {
          line: 431,
          column: 28
        }
      },
      "55": {
        start: {
          line: 436,
          column: 4
        },
        end: {
          line: 436,
          column: 80
        }
      },
      "56": {
        start: {
          line: 439,
          column: 28
        },
        end: {
          line: 441,
          column: 3
        }
      },
      "57": {
        start: {
          line: 440,
          column: 4
        },
        end: {
          line: 440,
          column: 53
        }
      },
      "58": {
        start: {
          line: 443,
          column: 23
        },
        end: {
          line: 448,
          column: 3
        }
      },
      "59": {
        start: {
          line: 444,
          column: 37
        },
        end: {
          line: 444,
          column: 47
        }
      },
      "60": {
        start: {
          line: 445,
          column: 4
        },
        end: {
          line: 447,
          column: 23
        }
      },
      "61": {
        start: {
          line: 446,
          column: 30
        },
        end: {
          line: 446,
          column: 63
        }
      },
      "62": {
        start: {
          line: 451,
          column: 24
        },
        end: {
          line: 451,
          column: 25
        }
      },
      "63": {
        start: {
          line: 452,
          column: 23
        },
        end: {
          line: 452,
          column: 64
        }
      },
      "64": {
        start: {
          line: 453,
          column: 4
        },
        end: {
          line: 462,
          column: 7
        }
      },
      "65": {
        start: {
          line: 454,
          column: 21
        },
        end: {
          line: 454,
          column: 45
        }
      },
      "66": {
        start: {
          line: 456,
          column: 6
        },
        end: {
          line: 460,
          column: 7
        }
      },
      "67": {
        start: {
          line: 458,
          column: 25
        },
        end: {
          line: 458,
          column: 53
        }
      },
      "68": {
        start: {
          line: 459,
          column: 8
        },
        end: {
          line: 459,
          column: 64
        }
      },
      "69": {
        start: {
          line: 461,
          column: 6
        },
        end: {
          line: 461,
          column: 19
        }
      },
      "70": {
        start: {
          line: 463,
          column: 4
        },
        end: {
          line: 469,
          column: 6
        }
      },
      "71": {
        start: {
          line: 473,
          column: 4
        },
        end: {
          line: 511,
          column: 5
        }
      },
      "72": {
        start: {
          line: 474,
          column: 66
        },
        end: {
          line: 474,
          column: 76
        }
      },
      "73": {
        start: {
          line: 475,
          column: 34
        },
        end: {
          line: 477,
          column: 7
        }
      },
      "74": {
        start: {
          line: 479,
          column: 6
        },
        end: {
          line: 484,
          column: 7
        }
      },
      "75": {
        start: {
          line: 480,
          column: 8
        },
        end: {
          line: 483,
          column: 11
        }
      },
      "76": {
        start: {
          line: 486,
          column: 6
        },
        end: {
          line: 510,
          column: 7
        }
      },
      "77": {
        start: {
          line: 488,
          column: 8
        },
        end: {
          line: 509,
          column: 9
        }
      },
      "78": {
        start: {
          line: 488,
          column: 21
        },
        end: {
          line: 488,
          column: 22
        }
      },
      "79": {
        start: {
          line: 489,
          column: 25
        },
        end: {
          line: 489,
          column: 45
        }
      },
      "80": {
        start: {
          line: 491,
          column: 10
        },
        end: {
          line: 508,
          column: 11
        }
      },
      "81": {
        start: {
          line: 493,
          column: 29
        },
        end: {
          line: 493,
          column: 57
        }
      },
      "82": {
        start: {
          line: 494,
          column: 29
        },
        end: {
          line: 494,
          column: 96
        }
      },
      "83": {
        start: {
          line: 495,
          column: 12
        },
        end: {
          line: 507,
          column: 15
        }
      },
      "84": {
        start: {
          line: 496,
          column: 14
        },
        end: {
          line: 506,
          column: 15
        }
      },
      "85": {
        start: {
          line: 497,
          column: 40
        },
        end: {
          line: 497,
          column: 66
        }
      },
      "86": {
        start: {
          line: 498,
          column: 44
        },
        end: {
          line: 498,
          column: 85
        }
      },
      "87": {
        start: {
          line: 499,
          column: 16
        },
        end: {
          line: 502,
          column: 17
        }
      },
      "88": {
        start: {
          line: 500,
          column: 18
        },
        end: {
          line: 500,
          column: 70
        }
      },
      "89": {
        start: {
          line: 501,
          column: 18
        },
        end: {
          line: 501,
          column: 65
        }
      },
      "90": {
        start: {
          line: 503,
          column: 16
        },
        end: {
          line: 505,
          column: 17
        }
      },
      "91": {
        start: {
          line: 504,
          column: 18
        },
        end: {
          line: 504,
          column: 96
        }
      },
      "92": {
        start: {
          line: 515,
          column: 37
        },
        end: {
          line: 515,
          column: 47
        }
      },
      "93": {
        start: {
          line: 516,
          column: 22
        },
        end: {
          line: 516,
          column: 53
        }
      },
      "94": {
        start: {
          line: 518,
          column: 4
        },
        end: {
          line: 520,
          column: 5
        }
      },
      "95": {
        start: {
          line: 519,
          column: 6
        },
        end: {
          line: 519,
          column: 50
        }
      },
      "96": {
        start: {
          line: 522,
          column: 4
        },
        end: {
          line: 528,
          column: 6
        }
      },
      "97": {
        start: {
          line: 532,
          column: 49
        },
        end: {
          line: 532,
          column: 59
        }
      },
      "98": {
        start: {
          line: 534,
          column: 22
        },
        end: {
          line: 534,
          column: 67
        }
      },
      "99": {
        start: {
          line: 536,
          column: 4
        },
        end: {
          line: 538,
          column: 5
        }
      },
      "100": {
        start: {
          line: 537,
          column: 6
        },
        end: {
          line: 537,
          column: 50
        }
      },
      "101": {
        start: {
          line: 540,
          column: 4
        },
        end: {
          line: 547,
          column: 6
        }
      },
      "102": {
        start: {
          line: 551,
          column: 41
        },
        end: {
          line: 551,
          column: 51
        }
      },
      "103": {
        start: {
          line: 553,
          column: 4
        },
        end: {
          line: 582,
          column: 5
        }
      },
      "104": {
        start: {
          line: 553,
          column: 17
        },
        end: {
          line: 553,
          column: 18
        }
      },
      "105": {
        start: {
          line: 554,
          column: 21
        },
        end: {
          line: 554,
          column: 41
        }
      },
      "106": {
        start: {
          line: 556,
          column: 6
        },
        end: {
          line: 581,
          column: 7
        }
      },
      "107": {
        start: {
          line: 558,
          column: 25
        },
        end: {
          line: 558,
          column: 53
        }
      },
      "108": {
        start: {
          line: 559,
          column: 25
        },
        end: {
          line: 559,
          column: 92
        }
      },
      "109": {
        start: {
          line: 560,
          column: 8
        },
        end: {
          line: 580,
          column: 11
        }
      },
      "110": {
        start: {
          line: 561,
          column: 34
        },
        end: {
          line: 561,
          column: 60
        }
      },
      "111": {
        start: {
          line: 562,
          column: 38
        },
        end: {
          line: 562,
          column: 79
        }
      },
      "112": {
        start: {
          line: 563,
          column: 10
        },
        end: {
          line: 579,
          column: 11
        }
      },
      "113": {
        start: {
          line: 564,
          column: 12
        },
        end: {
          line: 567,
          column: 13
        }
      },
      "114": {
        start: {
          line: 565,
          column: 14
        },
        end: {
          line: 565,
          column: 61
        }
      },
      "115": {
        start: {
          line: 566,
          column: 14
        },
        end: {
          line: 566,
          column: 60
        }
      },
      "116": {
        start: {
          line: 568,
          column: 12
        },
        end: {
          line: 570,
          column: 13
        }
      },
      "117": {
        start: {
          line: 569,
          column: 14
        },
        end: {
          line: 569,
          column: 87
        }
      },
      "118": {
        start: {
          line: 572,
          column: 12
        },
        end: {
          line: 575,
          column: 13
        }
      },
      "119": {
        start: {
          line: 573,
          column: 14
        },
        end: {
          line: 573,
          column: 66
        }
      },
      "120": {
        start: {
          line: 574,
          column: 14
        },
        end: {
          line: 574,
          column: 61
        }
      },
      "121": {
        start: {
          line: 576,
          column: 12
        },
        end: {
          line: 578,
          column: 13
        }
      },
      "122": {
        start: {
          line: 577,
          column: 14
        },
        end: {
          line: 577,
          column: 92
        }
      },
      "123": {
        start: {
          line: 585,
          column: 19
        },
        end: {
          line: 589,
          column: 3
        }
      },
      "124": {
        start: {
          line: 586,
          column: 36
        },
        end: {
          line: 586,
          column: 46
        }
      },
      "125": {
        start: {
          line: 587,
          column: 21
        },
        end: {
          line: 587,
          column: 87
        }
      },
      "126": {
        start: {
          line: 588,
          column: 4
        },
        end: {
          line: 588,
          column: 32
        }
      },
      "127": {
        start: {
          line: 592,
          column: 69
        },
        end: {
          line: 592,
          column: 79
        }
      },
      "128": {
        start: {
          line: 600,
          column: 8
        },
        end: {
          line: 600,
          column: 18
        }
      },
      "129": {
        start: {
          line: 601,
          column: 29
        },
        end: {
          line: 601,
          column: 77
        }
      },
      "130": {
        start: {
          line: 602,
          column: 28
        },
        end: {
          line: 602,
          column: 38
        }
      },
      "131": {
        start: {
          line: 603,
          column: 29
        },
        end: {
          line: 603,
          column: 63
        }
      },
      "132": {
        start: {
          line: 605,
          column: 4
        },
        end: {
          line: 664,
          column: 6
        }
      },
      "133": {
        start: {
          line: 609,
          column: 10
        },
        end: {
          line: 609,
          column: 30
        }
      },
      "134": {
        start: {
          line: 614,
          column: 26
        },
        end: {
          line: 614,
          column: 62
        }
      },
      "135": {
        start: {
          line: 625,
          column: 12
        },
        end: {
          line: 625,
          column: 25
        }
      },
      "136": {
        start: {
          line: 626,
          column: 12
        },
        end: {
          line: 626,
          column: 22
        }
      },
      "137": {
        start: {
          line: 641,
          column: 14
        },
        end: {
          line: 641,
          column: 25
        }
      },
      "138": {
        start: {
          line: 642,
          column: 14
        },
        end: {
          line: 642,
          column: 23
        }
      },
      "139": {
        start: {
          line: 645,
          column: 14
        },
        end: {
          line: 650,
          column: 16
        }
      },
      "140": {
        start: {
          line: 647,
          column: 18
        },
        end: {
          line: 647,
          column: 48
        }
      },
      "141": {
        start: {
          line: 648,
          column: 18
        },
        end: {
          line: 648,
          column: 30
        }
      },
      "142": {
        start: {
          line: 658,
          column: 26
        },
        end: {
          line: 658,
          column: 58
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 55,
            column: 6
          },
          end: {
            line: 55,
            column: 7
          }
        },
        loc: {
          start: {
            line: 56,
            column: 6
          },
          end: {
            line: 59,
            column: 7
          }
        },
        line: 56
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 79,
            column: 8
          },
          end: {
            line: 79,
            column: 9
          }
        },
        loc: {
          start: {
            line: 80,
            column: 8
          },
          end: {
            line: 83,
            column: 9
          }
        },
        line: 80
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 109,
            column: 8
          },
          end: {
            line: 109,
            column: 9
          }
        },
        loc: {
          start: {
            line: 110,
            column: 8
          },
          end: {
            line: 117,
            column: 9
          }
        },
        line: 110
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 124,
            column: 30
          },
          end: {
            line: 124,
            column: 31
          }
        },
        loc: {
          start: {
            line: 124,
            column: 48
          },
          end: {
            line: 124,
            column: 68
          }
        },
        line: 124
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 141,
            column: 8
          },
          end: {
            line: 141,
            column: 9
          }
        },
        loc: {
          start: {
            line: 144,
            column: 8
          },
          end: {
            line: 150,
            column: 9
          }
        },
        line: 144
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 152,
            column: 8
          },
          end: {
            line: 152,
            column: 9
          }
        },
        loc: {
          start: {
            line: 153,
            column: 8
          },
          end: {
            line: 156,
            column: 9
          }
        },
        line: 153
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 158,
            column: 8
          },
          end: {
            line: 158,
            column: 9
          }
        },
        loc: {
          start: {
            line: 159,
            column: 8
          },
          end: {
            line: 185,
            column: 9
          }
        },
        line: 159
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 161,
            column: 12
          },
          end: {
            line: 161,
            column: 13
          }
        },
        loc: {
          start: {
            line: 162,
            column: 12
          },
          end: {
            line: 184,
            column: 13
          }
        },
        line: 162
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 193,
            column: 10
          },
          end: {
            line: 193,
            column: 11
          }
        },
        loc: {
          start: {
            line: 194,
            column: 10
          },
          end: {
            line: 194,
            column: 57
          }
        },
        line: 194
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 199,
            column: 23
          },
          end: {
            line: 199,
            column: 24
          }
        },
        loc: {
          start: {
            line: 199,
            column: 64
          },
          end: {
            line: 206,
            column: 1
          }
        },
        line: 199
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 222,
            column: 20
          },
          end: {
            line: 222,
            column: 21
          }
        },
        loc: {
          start: {
            line: 222,
            column: 30
          },
          end: {
            line: 222,
            column: 63
          }
        },
        line: 222
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 224,
            column: 8
          },
          end: {
            line: 224,
            column: 9
          }
        },
        loc: {
          start: {
            line: 225,
            column: 8
          },
          end: {
            line: 228,
            column: 3
          }
        },
        line: 225
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 230,
            column: 15
          },
          end: {
            line: 230,
            column: 16
          }
        },
        loc: {
          start: {
            line: 230,
            column: 24
          },
          end: {
            line: 230,
            column: 53
          }
        },
        line: 230
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 231,
            column: 14
          },
          end: {
            line: 231,
            column: 15
          }
        },
        loc: {
          start: {
            line: 231,
            column: 23
          },
          end: {
            line: 231,
            column: 51
          }
        },
        line: 231
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 234,
            column: 15
          },
          end: {
            line: 234,
            column: 16
          }
        },
        loc: {
          start: {
            line: 234,
            column: 24
          },
          end: {
            line: 234,
            column: 87
          }
        },
        line: 234
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 238,
            column: 28
          },
          end: {
            line: 238,
            column: 29
          }
        },
        loc: {
          start: {
            line: 239,
            column: 10
          },
          end: {
            line: 243,
            column: 19
          }
        },
        line: 239
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 249,
            column: 16
          },
          end: {
            line: 249,
            column: 17
          }
        },
        loc: {
          start: {
            line: 249,
            column: 25
          },
          end: {
            line: 249,
            column: 106
          }
        },
        line: 249
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 256,
            column: 20
          },
          end: {
            line: 256,
            column: 21
          }
        },
        loc: {
          start: {
            line: 256,
            column: 30
          },
          end: {
            line: 256,
            column: 63
          }
        },
        line: 256
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 258,
            column: 8
          },
          end: {
            line: 258,
            column: 9
          }
        },
        loc: {
          start: {
            line: 259,
            column: 8
          },
          end: {
            line: 262,
            column: 7
          }
        },
        line: 259
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 265,
            column: 8
          },
          end: {
            line: 265,
            column: 9
          }
        },
        loc: {
          start: {
            line: 265,
            column: 22
          },
          end: {
            line: 265,
            column: 52
          }
        },
        line: 265
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 268,
            column: 15
          },
          end: {
            line: 268,
            column: 16
          }
        },
        loc: {
          start: {
            line: 268,
            column: 24
          },
          end: {
            line: 268,
            column: 87
          }
        },
        line: 268
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 276,
            column: 10
          },
          end: {
            line: 276,
            column: 11
          }
        },
        loc: {
          start: {
            line: 276,
            column: 93
          },
          end: {
            line: 289,
            column: 9
          }
        },
        line: 276
      },
      "22": {
        name: "SideChevronNT",
        decl: {
          start: {
            line: 301,
            column: 9
          },
          end: {
            line: 301,
            column: 22
          }
        },
        loc: {
          start: {
            line: 301,
            column: 51
          },
          end: {
            line: 339,
            column: 1
          }
        },
        line: 301
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 302,
            column: 22
          },
          end: {
            line: 302,
            column: 23
          }
        },
        loc: {
          start: {
            line: 302,
            column: 28
          },
          end: {
            line: 311,
            column: 3
          }
        },
        line: 302
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 313,
            column: 22
          },
          end: {
            line: 313,
            column: 23
          }
        },
        loc: {
          start: {
            line: 313,
            column: 28
          },
          end: {
            line: 322,
            column: 3
          }
        },
        line: 313
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 404,
            column: 2
          },
          end: {
            line: 404,
            column: 3
          }
        },
        loc: {
          start: {
            line: 404,
            column: 21
          },
          end: {
            line: 417,
            column: 3
          }
        },
        line: 404
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 419,
            column: 2
          },
          end: {
            line: 419,
            column: 3
          }
        },
        loc: {
          start: {
            line: 419,
            column: 22
          },
          end: {
            line: 423,
            column: 3
          }
        },
        line: 419
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 425,
            column: 2
          },
          end: {
            line: 425,
            column: 3
          }
        },
        loc: {
          start: {
            line: 425,
            column: 30
          },
          end: {
            line: 427,
            column: 3
          }
        },
        line: 425
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 429,
            column: 2
          },
          end: {
            line: 429,
            column: 3
          }
        },
        loc: {
          start: {
            line: 429,
            column: 43
          },
          end: {
            line: 433,
            column: 3
          }
        },
        line: 429
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 435,
            column: 2
          },
          end: {
            line: 435,
            column: 3
          }
        },
        loc: {
          start: {
            line: 435,
            column: 25
          },
          end: {
            line: 437,
            column: 3
          }
        },
        line: 435
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 439,
            column: 28
          },
          end: {
            line: 439,
            column: 29
          }
        },
        loc: {
          start: {
            line: 439,
            column: 34
          },
          end: {
            line: 441,
            column: 3
          }
        },
        line: 439
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 443,
            column: 23
          },
          end: {
            line: 443,
            column: 24
          }
        },
        loc: {
          start: {
            line: 443,
            column: 29
          },
          end: {
            line: 448,
            column: 3
          }
        },
        line: 443
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 446,
            column: 11
          },
          end: {
            line: 446,
            column: 12
          }
        },
        loc: {
          start: {
            line: 446,
            column: 30
          },
          end: {
            line: 446,
            column: 63
          }
        },
        line: 446
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 450,
            column: 2
          },
          end: {
            line: 450,
            column: 3
          }
        },
        loc: {
          start: {
            line: 450,
            column: 26
          },
          end: {
            line: 470,
            column: 3
          }
        },
        line: 450
      },
      "34": {
        name: "(anonymous_34)",
        decl: {
          start: {
            line: 453,
            column: 38
          },
          end: {
            line: 453,
            column: 39
          }
        },
        loc: {
          start: {
            line: 453,
            column: 56
          },
          end: {
            line: 462,
            column: 5
          }
        },
        line: 453
      },
      "35": {
        name: "(anonymous_35)",
        decl: {
          start: {
            line: 472,
            column: 2
          },
          end: {
            line: 472,
            column: 3
          }
        },
        loc: {
          start: {
            line: 472,
            column: 11
          },
          end: {
            line: 512,
            column: 3
          }
        },
        line: 472
      },
      "36": {
        name: "(anonymous_36)",
        decl: {
          start: {
            line: 495,
            column: 29
          },
          end: {
            line: 495,
            column: 30
          }
        },
        loc: {
          start: {
            line: 495,
            column: 40
          },
          end: {
            line: 507,
            column: 13
          }
        },
        line: 495
      },
      "37": {
        name: "(anonymous_37)",
        decl: {
          start: {
            line: 514,
            column: 2
          },
          end: {
            line: 514,
            column: 3
          }
        },
        loc: {
          start: {
            line: 514,
            column: 13
          },
          end: {
            line: 529,
            column: 3
          }
        },
        line: 514
      },
      "38": {
        name: "(anonymous_38)",
        decl: {
          start: {
            line: 531,
            column: 2
          },
          end: {
            line: 531,
            column: 3
          }
        },
        loc: {
          start: {
            line: 531,
            column: 9
          },
          end: {
            line: 548,
            column: 3
          }
        },
        line: 531
      },
      "39": {
        name: "(anonymous_39)",
        decl: {
          start: {
            line: 550,
            column: 2
          },
          end: {
            line: 550,
            column: 3
          }
        },
        loc: {
          start: {
            line: 550,
            column: 38
          },
          end: {
            line: 583,
            column: 3
          }
        },
        line: 550
      },
      "40": {
        name: "(anonymous_40)",
        decl: {
          start: {
            line: 560,
            column: 25
          },
          end: {
            line: 560,
            column: 26
          }
        },
        loc: {
          start: {
            line: 560,
            column: 36
          },
          end: {
            line: 580,
            column: 9
          }
        },
        line: 560
      },
      "41": {
        name: "(anonymous_41)",
        decl: {
          start: {
            line: 585,
            column: 19
          },
          end: {
            line: 585,
            column: 20
          }
        },
        loc: {
          start: {
            line: 585,
            column: 25
          },
          end: {
            line: 589,
            column: 3
          }
        },
        line: 585
      },
      "42": {
        name: "(anonymous_42)",
        decl: {
          start: {
            line: 591,
            column: 2
          },
          end: {
            line: 591,
            column: 3
          }
        },
        loc: {
          start: {
            line: 591,
            column: 11
          },
          end: {
            line: 665,
            column: 3
          }
        },
        line: 591
      },
      "43": {
        name: "(anonymous_43)",
        decl: {
          start: {
            line: 608,
            column: 18
          },
          end: {
            line: 608,
            column: 19
          }
        },
        loc: {
          start: {
            line: 608,
            column: 26
          },
          end: {
            line: 610,
            column: 9
          }
        },
        line: 608
      },
      "44": {
        name: "(anonymous_44)",
        decl: {
          start: {
            line: 614,
            column: 21
          },
          end: {
            line: 614,
            column: 22
          }
        },
        loc: {
          start: {
            line: 614,
            column: 26
          },
          end: {
            line: 614,
            column: 62
          }
        },
        line: 614
      },
      "45": {
        name: "(anonymous_45)",
        decl: {
          start: {
            line: 624,
            column: 20
          },
          end: {
            line: 624,
            column: 21
          }
        },
        loc: {
          start: {
            line: 624,
            column: 26
          },
          end: {
            line: 627,
            column: 11
          }
        },
        line: 624
      },
      "46": {
        name: "(anonymous_46)",
        decl: {
          start: {
            line: 640,
            column: 22
          },
          end: {
            line: 640,
            column: 23
          }
        },
        loc: {
          start: {
            line: 640,
            column: 27
          },
          end: {
            line: 643,
            column: 13
          }
        },
        line: 640
      },
      "47": {
        name: "(anonymous_47)",
        decl: {
          start: {
            line: 644,
            column: 42
          },
          end: {
            line: 644,
            column: 43
          }
        },
        loc: {
          start: {
            line: 645,
            column: 14
          },
          end: {
            line: 650,
            column: 16
          }
        },
        line: 645
      },
      "48": {
        name: "(anonymous_48)",
        decl: {
          start: {
            line: 646,
            column: 21
          },
          end: {
            line: 646,
            column: 22
          }
        },
        loc: {
          start: {
            line: 646,
            column: 29
          },
          end: {
            line: 649,
            column: 17
          }
        },
        line: 646
      },
      "49": {
        name: "(anonymous_49)",
        decl: {
          start: {
            line: 658,
            column: 21
          },
          end: {
            line: 658,
            column: 22
          }
        },
        loc: {
          start: {
            line: 658,
            column: 26
          },
          end: {
            line: 658,
            column: 58
          }
        },
        line: 658
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 60,
            column: 3
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 50,
            column: 17
          }
        }, {
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 60,
            column: 3
          }
        }],
        line: 50
      },
      "1": {
        loc: {
          start: {
            line: 56,
            column: 6
          },
          end: {
            line: 59,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 56,
            column: 7
          },
          end: {
            line: 56,
            column: 20
          }
        }, {
          start: {
            line: 56,
            column: 24
          },
          end: {
            line: 56,
            column: 33
          }
        }, {
          start: {
            line: 57,
            column: 6
          },
          end: {
            line: 59,
            column: 7
          }
        }],
        line: 56
      },
      "2": {
        loc: {
          start: {
            line: 80,
            column: 8
          },
          end: {
            line: 83,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 80,
            column: 9
          },
          end: {
            line: 80,
            column: 22
          }
        }, {
          start: {
            line: 80,
            column: 26
          },
          end: {
            line: 80,
            column: 35
          }
        }, {
          start: {
            line: 81,
            column: 8
          },
          end: {
            line: 83,
            column: 9
          }
        }],
        line: 80
      },
      "3": {
        loc: {
          start: {
            line: 110,
            column: 8
          },
          end: {
            line: 117,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 110,
            column: 9
          },
          end: {
            line: 110,
            column: 22
          }
        }, {
          start: {
            line: 110,
            column: 26
          },
          end: {
            line: 110,
            column: 35
          }
        }, {
          start: {
            line: 111,
            column: 8
          },
          end: {
            line: 117,
            column: 9
          }
        }],
        line: 110
      },
      "4": {
        loc: {
          start: {
            line: 144,
            column: 8
          },
          end: {
            line: 150,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 144,
            column: 8
          },
          end: {
            line: 144,
            column: 26
          }
        }, {
          start: {
            line: 145,
            column: 9
          },
          end: {
            line: 145,
            column: 22
          }
        }, {
          start: {
            line: 145,
            column: 26
          },
          end: {
            line: 145,
            column: 35
          }
        }, {
          start: {
            line: 146,
            column: 8
          },
          end: {
            line: 150,
            column: 9
          }
        }],
        line: 144
      },
      "5": {
        loc: {
          start: {
            line: 153,
            column: 8
          },
          end: {
            line: 156,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 153,
            column: 9
          },
          end: {
            line: 153,
            column: 22
          }
        }, {
          start: {
            line: 153,
            column: 26
          },
          end: {
            line: 153,
            column: 35
          }
        }, {
          start: {
            line: 154,
            column: 8
          },
          end: {
            line: 156,
            column: 9
          }
        }],
        line: 153
      },
      "6": {
        loc: {
          start: {
            line: 159,
            column: 8
          },
          end: {
            line: 185,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 159,
            column: 8
          },
          end: {
            line: 159,
            column: 33
          }
        }, {
          start: {
            line: 160,
            column: 8
          },
          end: {
            line: 185,
            column: 9
          }
        }],
        line: 159
      },
      "7": {
        loc: {
          start: {
            line: 162,
            column: 12
          },
          end: {
            line: 184,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 162,
            column: 12
          },
          end: {
            line: 162,
            column: 41
          }
        }, {
          start: {
            line: 163,
            column: 12
          },
          end: {
            line: 184,
            column: 13
          }
        }],
        line: 162
      },
      "8": {
        loc: {
          start: {
            line: 162,
            column: 14
          },
          end: {
            line: 162,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 162,
            column: 14
          },
          end: {
            line: 162,
            column: 23
          }
        }, {
          start: {
            line: 162,
            column: 27
          },
          end: {
            line: 162,
            column: 40
          }
        }],
        line: 162
      },
      "9": {
        loc: {
          start: {
            line: 193,
            column: 23
          },
          end: {
            line: 193,
            column: 38
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 193,
            column: 37
          },
          end: {
            line: 193,
            column: 38
          }
        }],
        line: 193
      },
      "10": {
        loc: {
          start: {
            line: 193,
            column: 40
          },
          end: {
            line: 193,
            column: 49
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 193,
            column: 48
          },
          end: {
            line: 193,
            column: 49
          }
        }],
        line: 193
      },
      "11": {
        loc: {
          start: {
            line: 200,
            column: 2
          },
          end: {
            line: 202,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 200,
            column: 2
          },
          end: {
            line: 202,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 200
      },
      "12": {
        loc: {
          start: {
            line: 205,
            column: 9
          },
          end: {
            line: 205,
            column: 81
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 205,
            column: 23
          },
          end: {
            line: 205,
            column: 68
          }
        }, {
          start: {
            line: 205,
            column: 71
          },
          end: {
            line: 205,
            column: 81
          }
        }],
        line: 205
      },
      "13": {
        loc: {
          start: {
            line: 222,
            column: 30
          },
          end: {
            line: 222,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 222,
            column: 43
          },
          end: {
            line: 222,
            column: 52
          }
        }, {
          start: {
            line: 222,
            column: 55
          },
          end: {
            line: 222,
            column: 63
          }
        }],
        line: 222
      },
      "14": {
        loc: {
          start: {
            line: 225,
            column: 8
          },
          end: {
            line: 228,
            column: 3
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 225,
            column: 9
          },
          end: {
            line: 225,
            column: 22
          }
        }, {
          start: {
            line: 225,
            column: 26
          },
          end: {
            line: 225,
            column: 35
          }
        }, {
          start: {
            line: 226,
            column: 8
          },
          end: {
            line: 228,
            column: 3
          }
        }],
        line: 225
      },
      "15": {
        loc: {
          start: {
            line: 230,
            column: 24
          },
          end: {
            line: 230,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 230,
            column: 24
          },
          end: {
            line: 230,
            column: 46
          }
        }, {
          start: {
            line: 230,
            column: 50
          },
          end: {
            line: 230,
            column: 53
          }
        }],
        line: 230
      },
      "16": {
        loc: {
          start: {
            line: 231,
            column: 23
          },
          end: {
            line: 231,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 231,
            column: 23
          },
          end: {
            line: 231,
            column: 44
          }
        }, {
          start: {
            line: 231,
            column: 48
          },
          end: {
            line: 231,
            column: 51
          }
        }],
        line: 231
      },
      "17": {
        loc: {
          start: {
            line: 239,
            column: 10
          },
          end: {
            line: 243,
            column: 19
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 239,
            column: 11
          },
          end: {
            line: 239,
            column: 16
          }
        }, {
          start: {
            line: 240,
            column: 12
          },
          end: {
            line: 240,
            column: 23
          }
        }, {
          start: {
            line: 241,
            column: 12
          },
          end: {
            line: 241,
            column: 33
          }
        }, {
          start: {
            line: 242,
            column: 12
          },
          end: {
            line: 242,
            column: 53
          }
        }, {
          start: {
            line: 243,
            column: 10
          },
          end: {
            line: 243,
            column: 19
          }
        }],
        line: 239
      },
      "18": {
        loc: {
          start: {
            line: 249,
            column: 25
          },
          end: {
            line: 249,
            column: 106
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 249,
            column: 53
          },
          end: {
            line: 249,
            column: 98
          }
        }, {
          start: {
            line: 249,
            column: 101
          },
          end: {
            line: 249,
            column: 106
          }
        }],
        line: 249
      },
      "19": {
        loc: {
          start: {
            line: 256,
            column: 30
          },
          end: {
            line: 256,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 256,
            column: 43
          },
          end: {
            line: 256,
            column: 52
          }
        }, {
          start: {
            line: 256,
            column: 55
          },
          end: {
            line: 256,
            column: 63
          }
        }],
        line: 256
      },
      "20": {
        loc: {
          start: {
            line: 259,
            column: 8
          },
          end: {
            line: 262,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 259,
            column: 9
          },
          end: {
            line: 259,
            column: 22
          }
        }, {
          start: {
            line: 259,
            column: 26
          },
          end: {
            line: 259,
            column: 35
          }
        }, {
          start: {
            line: 260,
            column: 8
          },
          end: {
            line: 262,
            column: 7
          }
        }],
        line: 259
      },
      "21": {
        loc: {
          start: {
            line: 276,
            column: 20
          },
          end: {
            line: 276,
            column: 86
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 276,
            column: 84
          },
          end: {
            line: 276,
            column: 86
          }
        }],
        line: 276
      },
      "22": {
        loc: {
          start: {
            line: 277,
            column: 30
          },
          end: {
            line: 277,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 277,
            column: 30
          },
          end: {
            line: 277,
            column: 43
          }
        }, {
          start: {
            line: 277,
            column: 47
          },
          end: {
            line: 277,
            column: 83
          }
        }],
        line: 277
      },
      "23": {
        loc: {
          start: {
            line: 278,
            column: 19
          },
          end: {
            line: 278,
            column: 86
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 278,
            column: 19
          },
          end: {
            line: 278,
            column: 36
          }
        }, {
          start: {
            line: 278,
            column: 40
          },
          end: {
            line: 278,
            column: 49
          }
        }, {
          start: {
            line: 278,
            column: 53
          },
          end: {
            line: 278,
            column: 86
          }
        }],
        line: 278
      },
      "24": {
        loc: {
          start: {
            line: 281,
            column: 46
          },
          end: {
            line: 281,
            column: 99
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 281,
            column: 46
          },
          end: {
            line: 281,
            column: 59
          }
        }, {
          start: {
            line: 281,
            column: 63
          },
          end: {
            line: 281,
            column: 99
          }
        }],
        line: 281
      },
      "25": {
        loc: {
          start: {
            line: 303,
            column: 4
          },
          end: {
            line: 310,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 306,
            column: 6
          },
          end: {
            line: 307,
            column: 56
          }
        }, {
          start: {
            line: 308,
            column: 6
          },
          end: {
            line: 309,
            column: 39
          }
        }],
        line: 303
      },
      "26": {
        loc: {
          start: {
            line: 314,
            column: 4
          },
          end: {
            line: 321,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 317,
            column: 6
          },
          end: {
            line: 318,
            column: 23
          }
        }, {
          start: {
            line: 319,
            column: 6
          },
          end: {
            line: 320,
            column: 24
          }
        }],
        line: 314
      },
      "27": {
        loc: {
          start: {
            line: 332,
            column: 10
          },
          end: {
            line: 332,
            column: 98
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 332,
            column: 10
          },
          end: {
            line: 332,
            column: 21
          }
        }, {
          start: {
            line: 332,
            column: 26
          },
          end: {
            line: 332,
            column: 37
          }
        }, {
          start: {
            line: 332,
            column: 41
          },
          end: {
            line: 332,
            column: 62
          }
        }, {
          start: {
            line: 332,
            column: 66
          },
          end: {
            line: 332,
            column: 97
          }
        }],
        line: 332
      },
      "28": {
        loc: {
          start: {
            line: 430,
            column: 4
          },
          end: {
            line: 432,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 430,
            column: 4
          },
          end: {
            line: 432,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 430
      },
      "29": {
        loc: {
          start: {
            line: 456,
            column: 6
          },
          end: {
            line: 460,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 456,
            column: 6
          },
          end: {
            line: 460,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 456
      },
      "30": {
        loc: {
          start: {
            line: 456,
            column: 10
          },
          end: {
            line: 456,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 456,
            column: 10
          },
          end: {
            line: 456,
            column: 16
          }
        }, {
          start: {
            line: 456,
            column: 20
          },
          end: {
            line: 456,
            column: 48
          }
        }],
        line: 456
      },
      "31": {
        loc: {
          start: {
            line: 473,
            column: 4
          },
          end: {
            line: 511,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 473,
            column: 4
          },
          end: {
            line: 511,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 473
      },
      "32": {
        loc: {
          start: {
            line: 479,
            column: 6
          },
          end: {
            line: 484,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 479,
            column: 6
          },
          end: {
            line: 484,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 479
      },
      "33": {
        loc: {
          start: {
            line: 486,
            column: 6
          },
          end: {
            line: 510,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 486,
            column: 6
          },
          end: {
            line: 510,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 486
      },
      "34": {
        loc: {
          start: {
            line: 491,
            column: 10
          },
          end: {
            line: 508,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 491,
            column: 10
          },
          end: {
            line: 508,
            column: 11
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 491
      },
      "35": {
        loc: {
          start: {
            line: 491,
            column: 14
          },
          end: {
            line: 491,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 491,
            column: 14
          },
          end: {
            line: 491,
            column: 20
          }
        }, {
          start: {
            line: 491,
            column: 24
          },
          end: {
            line: 491,
            column: 52
          }
        }],
        line: 491
      },
      "36": {
        loc: {
          start: {
            line: 496,
            column: 14
          },
          end: {
            line: 506,
            column: 15
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 496,
            column: 14
          },
          end: {
            line: 506,
            column: 15
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 496
      },
      "37": {
        loc: {
          start: {
            line: 496,
            column: 18
          },
          end: {
            line: 496,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 496,
            column: 18
          },
          end: {
            line: 496,
            column: 25
          }
        }, {
          start: {
            line: 496,
            column: 29
          },
          end: {
            line: 496,
            column: 62
          }
        }],
        line: 496
      },
      "38": {
        loc: {
          start: {
            line: 499,
            column: 16
          },
          end: {
            line: 502,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 499,
            column: 16
          },
          end: {
            line: 502,
            column: 17
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 499
      },
      "39": {
        loc: {
          start: {
            line: 503,
            column: 16
          },
          end: {
            line: 505,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 503,
            column: 16
          },
          end: {
            line: 505,
            column: 17
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 503
      },
      "40": {
        loc: {
          start: {
            line: 516,
            column: 22
          },
          end: {
            line: 516,
            column: 53
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 516,
            column: 39
          },
          end: {
            line: 516,
            column: 49
          }
        }, {
          start: {
            line: 516,
            column: 52
          },
          end: {
            line: 516,
            column: 53
          }
        }],
        line: 516
      },
      "41": {
        loc: {
          start: {
            line: 518,
            column: 4
          },
          end: {
            line: 520,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 518,
            column: 4
          },
          end: {
            line: 520,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 518
      },
      "42": {
        loc: {
          start: {
            line: 534,
            column: 22
          },
          end: {
            line: 534,
            column: 67
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 534,
            column: 48
          },
          end: {
            line: 534,
            column: 58
          }
        }, {
          start: {
            line: 534,
            column: 61
          },
          end: {
            line: 534,
            column: 67
          }
        }],
        line: 534
      },
      "43": {
        loc: {
          start: {
            line: 536,
            column: 4
          },
          end: {
            line: 538,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 536,
            column: 4
          },
          end: {
            line: 538,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 536
      },
      "44": {
        loc: {
          start: {
            line: 556,
            column: 6
          },
          end: {
            line: 581,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 556,
            column: 6
          },
          end: {
            line: 581,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 556
      },
      "45": {
        loc: {
          start: {
            line: 556,
            column: 10
          },
          end: {
            line: 556,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 556,
            column: 10
          },
          end: {
            line: 556,
            column: 16
          }
        }, {
          start: {
            line: 556,
            column: 20
          },
          end: {
            line: 556,
            column: 48
          }
        }],
        line: 556
      },
      "46": {
        loc: {
          start: {
            line: 563,
            column: 10
          },
          end: {
            line: 579,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 563,
            column: 10
          },
          end: {
            line: 579,
            column: 11
          }
        }, {
          start: {
            line: 571,
            column: 17
          },
          end: {
            line: 579,
            column: 11
          }
        }],
        line: 563
      },
      "47": {
        loc: {
          start: {
            line: 563,
            column: 14
          },
          end: {
            line: 563,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 563,
            column: 14
          },
          end: {
            line: 563,
            column: 25
          }
        }, {
          start: {
            line: 563,
            column: 29
          },
          end: {
            line: 563,
            column: 54
          }
        }],
        line: 563
      },
      "48": {
        loc: {
          start: {
            line: 564,
            column: 12
          },
          end: {
            line: 567,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 564,
            column: 12
          },
          end: {
            line: 567,
            column: 13
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 564
      },
      "49": {
        loc: {
          start: {
            line: 568,
            column: 12
          },
          end: {
            line: 570,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 568,
            column: 12
          },
          end: {
            line: 570,
            column: 13
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 568
      },
      "50": {
        loc: {
          start: {
            line: 572,
            column: 12
          },
          end: {
            line: 575,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 572,
            column: 12
          },
          end: {
            line: 575,
            column: 13
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 572
      },
      "51": {
        loc: {
          start: {
            line: 576,
            column: 12
          },
          end: {
            line: 578,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 576,
            column: 12
          },
          end: {
            line: 578,
            column: 13
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 576
      },
      "52": {
        loc: {
          start: {
            line: 587,
            column: 21
          },
          end: {
            line: 587,
            column: 87
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 587,
            column: 21
          },
          end: {
            line: 587,
            column: 40
          }
        }, {
          start: {
            line: 587,
            column: 44
          },
          end: {
            line: 587,
            column: 87
          }
        }],
        line: 587
      },
      "53": {
        loc: {
          start: {
            line: 614,
            column: 26
          },
          end: {
            line: 614,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 614,
            column: 26
          },
          end: {
            line: 614,
            column: 43
          }
        }, {
          start: {
            line: 614,
            column: 47
          },
          end: {
            line: 614,
            column: 62
          }
        }],
        line: 614
      },
      "54": {
        loc: {
          start: {
            line: 617,
            column: 31
          },
          end: {
            line: 617,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 617,
            column: 31
          },
          end: {
            line: 617,
            column: 39
          }
        }, {
          start: {
            line: 617,
            column: 43
          },
          end: {
            line: 617,
            column: 55
          }
        }],
        line: 617
      },
      "55": {
        loc: {
          start: {
            line: 631,
            column: 16
          },
          end: {
            line: 631,
            column: 94
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 631,
            column: 16
          },
          end: {
            line: 631,
            column: 45
          }
        }, {
          start: {
            line: 631,
            column: 49
          },
          end: {
            line: 631,
            column: 65
          }
        }, {
          start: {
            line: 631,
            column: 69
          },
          end: {
            line: 631,
            column: 94
          }
        }],
        line: 631
      },
      "56": {
        loc: {
          start: {
            line: 631,
            column: 18
          },
          end: {
            line: 631,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 631,
            column: 18
          },
          end: {
            line: 631,
            column: 27
          }
        }, {
          start: {
            line: 631,
            column: 31
          },
          end: {
            line: 631,
            column: 44
          }
        }],
        line: 631
      },
      "57": {
        loc: {
          start: {
            line: 658,
            column: 26
          },
          end: {
            line: 658,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 658,
            column: 26
          },
          end: {
            line: 658,
            column: 43
          }
        }, {
          start: {
            line: 658,
            column: 47
          },
          end: {
            line: 658,
            column: 58
          }
        }],
        line: 658
      },
      "58": {
        loc: {
          start: {
            line: 660,
            column: 31
          },
          end: {
            line: 660,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 660,
            column: 31
          },
          end: {
            line: 660,
            column: 39
          }
        }, {
          start: {
            line: 660,
            column: 43
          },
          end: {
            line: 660,
            column: 55
          }
        }],
        line: 660
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0],
      "2": [0, 0, 0],
      "3": [0, 0, 0],
      "4": [0, 0, 0, 0],
      "5": [0, 0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0],
      "10": [0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0, 0, 0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0, 0],
      "21": [0],
      "22": [0, 0],
      "23": [0, 0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0, 0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0],
      "52": [0, 0],
      "53": [0, 0],
      "54": [0, 0],
      "55": [0, 0, 0],
      "56": [0, 0],
      "57": [0, 0],
      "58": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c9ae74d26da86d487a7586b60d9896b4003a6ae4"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1o978z52du = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1o978z52du();
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var _ref = (cov_1o978z52du().s[0]++, _stylingConstants.default),
  spacing = _ref.spacing,
  font = _ref.font;
var Wrapper = (cov_1o978z52du().s[1]++, _styledComponents.default.div.attrs({
  className: 'g-FilmStrip'
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  box-sizing: border-box;\n"]))));
var SliderContainer = (cov_1o978z52du().s[2]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: 'g-FilmStrip-sliderContainer',
  role: 'region',
  'aria-label': 'Carousel'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      position: relative;\n      box-sizing: border-box;\n      overflow-y: hidden;\n      margin-left: -", ";\n      margin-right: -", ";\n      -webkit-overflow-scrolling: touch;\n      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n      -webkit-tap-highlight-color: transparent;\n      display: flex;\n      &::-webkit-scrollbar {\n        -webkit-appearance: none;\n        display: none;\n      }\n\n      ", ";\n    "])), spacing.medium, spacing.medium, (cov_1o978z52du().b[0][0]++, _reactDeviceDetect.isDesktop) && (cov_1o978z52du().b[0][1]++, "\n    margin-left: 0;\n    margin-right: 0;\n    overflow: hidden;\n    ".concat(function (_ref2) {
  var desktopSlider = _ref2.desktopSlider;
  cov_1o978z52du().f[0]++;
  cov_1o978z52du().s[3]++;
  return ((cov_1o978z52du().b[1][0]++, desktopSlider) || (cov_1o978z52du().b[1][1]++, _reactDeviceDetect.isDesktop)) && (cov_1o978z52du().b[1][2]++, (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n        overflow: hidden;\n      "]))));
}, ";\n  ")))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n      position: relative;\n      box-sizing: border-box;\n\n      -webkit-overflow-scrolling: touch;\n      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n      -webkit-tap-highlight-color: transparent;\n      display: flex;\n      overflow-y: hidden;\n      // Negative margin to expand the container with the same amount of padding of slider\n      // To make the display space of children as large as this origin size\n      margin: -", "px;\n      &::-webkit-scrollbar {\n        -webkit-appearance: none;\n        display: none;\n      }\n\n      ", ";\n    "])), _themeMapper.evolutionTheme.spacings.xl, function (_ref3) {
  var desktopSlider = _ref3.desktopSlider;
  cov_1o978z52du().f[1]++;
  cov_1o978z52du().s[4]++;
  return ((cov_1o978z52du().b[2][0]++, desktopSlider) || (cov_1o978z52du().b[2][1]++, _reactDeviceDetect.isDesktop)) && (cov_1o978z52du().b[2][2]++, (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n          overflow: hidden;\n        "]))));
}))));
var Slider = (cov_1o978z52du().s[5]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: 'g-FilmStrip-slider'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n      transition: transform 0.5s;\n      white-space: nowrap;\n\n      overflow: -moz-scrollbars-none;\n      width: 100%;\n      transform: translateX(0);\n      overflow-x: auto;\n      overflow-y: hidden;\n      margin-bottom: -30px;\n      padding: 0 ", " 30px ", ";\n\n      > :last-child {\n        margin-right: -", ";\n      }\n\n      ", ";\n\n      &::-webkit-scrollbar {\n        -webkit-appearance: none;\n        display: none;\n      }\n\n      transform: translateX(", ");\n    "])), spacing.xlarge, spacing.medium, spacing.medium, function (_ref4) {
  var desktopSlider = _ref4.desktopSlider;
  cov_1o978z52du().f[2]++;
  cov_1o978z52du().s[6]++;
  return ((cov_1o978z52du().b[3][0]++, desktopSlider) || (cov_1o978z52du().b[3][1]++, _reactDeviceDetect.isDesktop)) && (cov_1o978z52du().b[3][2]++, (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n          padding: 0 0 30px 0;\n          overflow: visible;\n          > :last-child {\n            margin-right: 0;\n          }\n        "]))));
}, function (_ref5) {
  var currentX = _ref5.currentX;
  cov_1o978z52du().f[3]++;
  cov_1o978z52du().s[7]++;
  return "calc(".concat(currentX, "%)");
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n      transition: transform 0.5s;\n      white-space: nowrap;\n\n      overflow: -moz-scrollbars-none;\n      transform: translateX(0);\n\n      overflow-x: auto;\n      overflow-y: hidden;\n\n      // Padding same amount with margin of slider container\n      // This make the children element show the box-shadow without overflowed hidden\n      padding: ", "px;\n      width: calc(100% - ", "px);\n\n      ", ";\n\n      ", ";\n\n      ", ";\n\n      &::-webkit-scrollbar {\n        -webkit-appearance: none;\n        display: none;\n      }\n\n      transform: translateX(\n        ", "\n      );\n    "])), _themeMapper.evolutionTheme.spacings.xl, _themeMapper.evolutionTheme.spacings.xl * 2, function (_ref6) {
  var visibleItems = _ref6.visibleItems,
    desktopSlider = _ref6.desktopSlider;
  cov_1o978z52du().f[4]++;
  cov_1o978z52du().s[8]++;
  return (
    // When is desktop and display as carousel
    // We margin double amount of padding the rest of children to hide it
    (cov_1o978z52du().b[4][0]++, visibleItems === 1) && ((cov_1o978z52du().b[4][1]++, desktopSlider) || (cov_1o978z52du().b[4][2]++, _reactDeviceDetect.isDesktop)) && (cov_1o978z52du().b[4][3]++, (0, _styledComponents.css)(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n          > :not(:first-child) {\n            margin-left: ", "px !important;\n          }\n        "])), _themeMapper.evolutionTheme.spacings.xl * 2))
  );
}, function (_ref7) {
  var desktopSlider = _ref7.desktopSlider;
  cov_1o978z52du().f[5]++;
  cov_1o978z52du().s[9]++;
  return ((cov_1o978z52du().b[5][0]++, desktopSlider) || (cov_1o978z52du().b[5][1]++, _reactDeviceDetect.isDesktop)) && (cov_1o978z52du().b[5][2]++, (0, _styledComponents.css)(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n          overflow: visible;\n        "]))));
}, function (_ref8) {
  var visibleItems = _ref8.visibleItems,
    totalItems = _ref8.totalItems;
  cov_1o978z52du().f[6]++;
  cov_1o978z52du().s[10]++;
  return (cov_1o978z52du().b[6][0]++, visibleItems < totalItems) && (cov_1o978z52du().b[6][1]++, (0, _styledComponents.css)(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2.default)(["\n          ", ";\n        "])), function (_ref9) {
    var desktopSlider = _ref9.desktopSlider;
    cov_1o978z52du().f[7]++;
    cov_1o978z52du().s[11]++;
    return (cov_1o978z52du().b[7][0]++, !((cov_1o978z52du().b[8][0]++, _reactDeviceDetect.isDesktop) || (cov_1o978z52du().b[8][1]++, desktopSlider))) && (cov_1o978z52du().b[7][1]++, (0, _styledComponents.css)(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2.default)(["\n              --sliding-visible-size: ", ";\n              --catalog-spacing-size: ", ";\n\n              ", ";\n\n              ", ";\n\n              padding-right: var(--sliding-visible-size);\n              width: calc(100% - ", "px - var(--sliding-visible-size));\n              overflow-y: visible;\n\n              > :last-child {\n                margin-right: calc(var(--catalog-spacing-size) - var(--sliding-visible-size));\n              }\n            "])), _themeMapper.evolutionTheme.filmStrip.slidingVisibleSize, _themeMapper.evolutionTheme.filmStrip.catalog.marginX, _utils.gMediaQueries.sm(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2.default)(["\n              --catalog-spacing-size: calc(", " + ", ");\n            "])), _themeMapper.evolutionTheme.catalog.padding, _themeMapper.evolutionTheme.filmStrip.catalog.marginX), _utils.gMediaQueries.xl(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2.default)(["\n              --catalog-spacing-size: ", ";\n            "])), _themeMapper.evolutionTheme.catalog.padding), _themeMapper.evolutionTheme.spacings.xl));
  }));
}, function (_ref10) {
  var currentX = _ref10.currentX,
    _ref10$itemSpacing = _ref10.itemSpacing,
    itemSpacing = _ref10$itemSpacing === void 0 ? (cov_1o978z52du().b[9][0]++, 0) : _ref10$itemSpacing,
    _ref10$slide = _ref10.slide,
    slide = _ref10$slide === void 0 ? (cov_1o978z52du().b[10][0]++, 0) : _ref10$slide;
  cov_1o978z52du().f[8]++;
  cov_1o978z52du().s[12]++;
  return "calc(".concat(currentX, "% + ").concat(itemSpacing * slide, "px)");
}))));
cov_1o978z52du().s[13]++;
var topComputation = function topComputation(selector, chevronHeight, topDefault) {
  cov_1o978z52du().f[9]++;
  cov_1o978z52du().s[14]++;
  if (!selector) {
    cov_1o978z52du().b[11][0]++;
    cov_1o978z52du().s[15]++;
    return topDefault;
  } else {
    cov_1o978z52du().b[11][1]++;
  }
  var childHeight = (cov_1o978z52du().s[16]++, selector.clientHeight / 2);
  // to display the chevron in the middle of the child: childHeight/2 - chevronHeight/2
  cov_1o978z52du().s[17]++;
  return childHeight ? (cov_1o978z52du().b[12][0]++, "calc(".concat(childHeight, "px - ").concat(chevronHeight, "/2)")) : (cov_1o978z52du().b[12][1]++, topDefault);
};
var Chevron = (cov_1o978z52du().s[18]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: 'g-FilmStrip-Chevron'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject15 || (_templateObject15 = (0, _taggedTemplateLiteral2.default)(["\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      padding: 0;\n      z-index: 1;\n      display: none;\n      cursor: pointer;\n      -webkit-tap-highlight-color: transparent;\n\n      visibility: ", ";\n\n      ", ";\n      width: ", ";\n      right: ", ";\n      left: ", ";\n\n      > .g-Icon {\n        top: ", ";\n        box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.14);\n        width: ", ";\n        height: ", ";\n        background-color: ", ";\n      }\n    "])), function (props) {
  cov_1o978z52du().f[10]++;
  cov_1o978z52du().s[19]++;
  return props.show ? (cov_1o978z52du().b[13][0]++, 'visible') : (cov_1o978z52du().b[13][1]++, 'hidden');
}, function (_ref11) {
  var desktopSlider = _ref11.desktopSlider;
  cov_1o978z52du().f[11]++;
  cov_1o978z52du().s[20]++;
  return ((cov_1o978z52du().b[14][0]++, desktopSlider) || (cov_1o978z52du().b[14][1]++, _reactDeviceDetect.isDesktop)) && (cov_1o978z52du().b[14][2]++, "\n      display: block;\n  ");
}, font.sizeXxxl, function (props) {
  cov_1o978z52du().f[12]++;
  cov_1o978z52du().s[21]++;
  return (cov_1o978z52du().b[15][0]++, props.side === 'right') && (cov_1o978z52du().b[15][1]++, "0");
}, function (props) {
  cov_1o978z52du().f[13]++;
  cov_1o978z52du().s[22]++;
  return (cov_1o978z52du().b[16][0]++, props.side === 'left') && (cov_1o978z52du().b[16][1]++, "0");
}, function (props) {
  cov_1o978z52du().f[14]++;
  cov_1o978z52du().s[23]++;
  return topComputation(props.childHeightSelector, font.sizeXxxl, '50%');
}, font.sizeXxxl, font.sizeXxxl, function (props) {
  cov_1o978z52du().f[15]++;
  cov_1o978z52du().s[24]++;
  return (cov_1o978z52du().b[17][0]++, props) && (cov_1o978z52du().b[17][1]++, props.theme) && (cov_1o978z52du().b[17][2]++, props.theme.filmStrip) && (cov_1o978z52du().b[17][3]++, props.theme.filmStrip.iconBackgroundColor) || (cov_1o978z52du().b[17][4]++, '#F7F7F7');
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject16 || (_templateObject16 = (0, _taggedTemplateLiteral2.default)(["\n      position: absolute;\n      top: 0;\n      height: ", ";\n      padding: 0;\n      z-index: 1;\n      display: none;\n      cursor: pointer;\n      -webkit-tap-highlight-color: transparent;\n\n      visibility: ", ";\n\n      ", ";\n      --iconSpacing: 10px;\n      width: ", ";\n      ", ";\n\n      > .g-Icon {\n        top: ", ";\n        box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 8px;\n        width: ", ";\n        height: ", ";\n        background-color: ", ";\n        border: 1px solid ", ";\n        border-radius: 50%;\n\n        ", ";\n\n        > svg {\n          width: 24px;\n          height: 24px;\n        }\n      }\n    "])), function (props) {
  cov_1o978z52du().f[16]++;
  cov_1o978z52du().s[25]++;
  return props.childHeightSelector ? (cov_1o978z52du().b[18][0]++, "".concat(props.childHeightSelector.clientHeight, "px")) : (cov_1o978z52du().b[18][1]++, '80%');
}, function (props) {
  cov_1o978z52du().f[17]++;
  cov_1o978z52du().s[26]++;
  return props.show ? (cov_1o978z52du().b[19][0]++, 'visible') : (cov_1o978z52du().b[19][1]++, 'hidden');
}, function (_ref12) {
  var desktopSlider = _ref12.desktopSlider;
  cov_1o978z52du().f[18]++;
  cov_1o978z52du().s[27]++;
  return ((cov_1o978z52du().b[20][0]++, desktopSlider) || (cov_1o978z52du().b[20][1]++, _reactDeviceDetect.isDesktop)) && (cov_1o978z52du().b[20][2]++, "\n          display: block;\n      ");
}, font.sizeXxxxl, function (_ref13) {
  var side = _ref13.side;
  cov_1o978z52du().f[19]++;
  cov_1o978z52du().s[28]++;
  return "".concat(side, ": var(--iconSpacing);");
}, function (props) {
  cov_1o978z52du().f[20]++;
  cov_1o978z52du().s[29]++;
  return topComputation(props.childHeightSelector, font.sizeXxxl, '50%');
}, font.sizeXxxxl, font.sizeXxxxl, _themeMapper.evolutionTheme.color.alpha.white[50], _themeMapper.evolutionTheme.color.alpha.black[10], function (_ref14) {
  var _ref14$theme = _ref14.theme,
    _ref14$theme2 = _ref14$theme === void 0 ? (cov_1o978z52du().b[21][0]++, {}) : _ref14$theme,
    tertiaryColor = _ref14$theme2.tertiaryColor,
    tertiaryTextColor = _ref14$theme2.tertiaryTextColor,
    textColor = _ref14$theme2.textColor,
    primaryColor = _ref14$theme2.primaryColor;
  cov_1o978z52du().f[21]++;
  cov_1o978z52du().s[30]++;
  return (0, _styledComponents.css)(_templateObject17 || (_templateObject17 = (0, _taggedTemplateLiteral2.default)(["\n          background-color: ", ";\n          color: ", ";\n\n          :hover {\n            background-color: ", ";\n          }\n\n          :active,\n          :focus,\n          :focus-within {\n            ", ";\n          }\n        "])), (cov_1o978z52du().b[22][0]++, tertiaryColor) || (cov_1o978z52du().b[22][1]++, _themeMapper.evolutionTheme.color.alpha.white[50]), (cov_1o978z52du().b[23][0]++, tertiaryTextColor) || (cov_1o978z52du().b[23][1]++, textColor) || (cov_1o978z52du().b[23][2]++, _themeMapper.evolutionTheme.color.primary[900]), (0, _polished.lighten)(0.05, (cov_1o978z52du().b[24][0]++, tertiaryColor) || (cov_1o978z52du().b[24][1]++, _themeMapper.evolutionTheme.color.alpha.white[50])), (0, _utils.boxShadow)(primaryColor));
}))));

/* Create a sideChevron object to pass the theme values to the icon */
function SideChevronNT(_ref15) {
  var themeContext = _ref15.themeContext,
    props = (0, _objectWithoutProperties2.default)(_ref15, _excluded);
  cov_1o978z52du().f[22]++;
  cov_1o978z52du().s[31]++;
  var getIconName = function getIconName() {
    cov_1o978z52du().f[23]++;
    cov_1o978z52du().s[32]++;
    switch (themeContext.theme // NOSONAR
    ) {
      case _themeProvider.TicketShopTheme.EVOLUTION:
        cov_1o978z52du().b[25][0]++;
        cov_1o978z52du().s[33]++;
        return "riArrow".concat((0, _lodash.upperFirst)(props.side), "SLine");
      default:
        cov_1o978z52du().b[25][1]++;
        cov_1o978z52du().s[34]++;
        return "chevron-".concat(props.side);
    }
  };
  cov_1o978z52du().s[35]++;
  var getIconSize = function getIconSize() {
    cov_1o978z52du().f[24]++;
    cov_1o978z52du().s[36]++;
    switch (themeContext.theme // NOSONAR
    ) {
      case _themeProvider.TicketShopTheme.EVOLUTION:
        cov_1o978z52du().b[26][0]++;
        cov_1o978z52du().s[37]++;
        return "small";
      default:
        cov_1o978z52du().b[26][1]++;
        cov_1o978z52du().s[38]++;
        return "xlarge";
    }
  };
  cov_1o978z52du().s[39]++;
  return /*#__PURE__*/_react.default.createElement(Chevron, (0, _extends2.default)({
    className: "g-FilmStrip-".concat(props.side, "Chevron")
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 325,
      columnNumber: 5
    }
  }), /*#__PURE__*/_react.default.createElement(_icon.default, {
    role: "button",
    tabIndex: 0,
    iconName: getIconName(),
    size: getIconSize(),
    iconColor: (cov_1o978z52du().b[27][0]++, props.color) || (cov_1o978z52du().b[27][1]++, props.theme) && (cov_1o978z52du().b[27][2]++, props.theme.filmStrip) && (cov_1o978z52du().b[27][3]++, props.theme.filmStrip.iconColor),
    onKeyDown: props.onKeyDown,
    "aria-label": props.ariaLabel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 326,
      columnNumber: 7
    }
  }));
}
cov_1o978z52du().s[40]++;
SideChevronNT.propTypes = {
  side: _propTypes.default.oneOf(['left', 'right']).isRequired,
  show: _propTypes.default.bool.isRequired,
  onClick: _propTypes.default.func.isRequired,
  onKeyDown: _propTypes.default.func.isRequired,
  color: _propTypes.default.string,
  theme: _propTypes.default.objectOf(_propTypes.default.string),
  childHeightSelector: _propTypes.default.node,
  ariaLabel: _propTypes.default.string,
  themeContext: _themeProvider.ThemeContextType
};
cov_1o978z52du().s[41]++;
SideChevronNT.defaultProps = {
  childHeightSelector: undefined,
  color: undefined,
  theme: null,
  ariaLabel: '',
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT
};
var SideChevron = (cov_1o978z52du().s[42]++, (0, _styledComponents.withTheme)((0, _themeProvider.withThemeConsumer)(SideChevronNT)));

/**
Component use to show horizontal items in a list with arrow to move to left or to right
*/
var FilmStrip = /*#__PURE__*/function (_PureComponent) {
  function FilmStrip(props) {
    var _this;
    (0, _classCallCheck2.default)(this, FilmStrip);
    cov_1o978z52du().f[25]++;
    cov_1o978z52du().s[45]++;
    _this = _callSuper(this, FilmStrip, [props]);
    (0, _defineProperty2.default)(_this, "onVisibleElementsChange", (cov_1o978z52du().s[56]++, function () {
      var _this$props$onChange, _this$props;
      cov_1o978z52du().f[30]++;
      cov_1o978z52du().s[57]++;
      (_this$props$onChange = (_this$props = _this.props).onChange) === null || _this$props$onChange === void 0 || _this$props$onChange.call(_this$props, _this.getVisibleElements()); // eslint-disable-line
    }));
    (0, _defineProperty2.default)(_this, "getVisibleElements", (cov_1o978z52du().s[58]++, function () {
      cov_1o978z52du().f[31]++;
      var _ref16 = (cov_1o978z52du().s[59]++, _this.state),
        visibleItems = _ref16.visibleItems,
        amount = _ref16.amount;
      cov_1o978z52du().s[60]++;
      return (0, _from.default)({
        length: visibleItems
      }).map(function (_value, index) {
        cov_1o978z52du().f[32]++;
        cov_1o978z52du().s[61]++;
        return _this["sliderEl".concat(index + amount)];
      }).filter(Boolean);
    }));
    (0, _defineProperty2.default)(_this, "updateSelector", (cov_1o978z52du().s[123]++, function () {
      cov_1o978z52du().f[41]++;
      var _ref17 = (cov_1o978z52du().s[124]++, _this.props),
        childHeightSelector = _ref17.childHeightSelector;
      var selector = (cov_1o978z52du().s[125]++, (cov_1o978z52du().b[52][0]++, childHeightSelector) && (cov_1o978z52du().b[52][1]++, document.querySelector(childHeightSelector)));
      cov_1o978z52du().s[126]++;
      _this.setState({
        selector: selector
      });
    }));
    cov_1o978z52du().s[46]++;
    _this.state = {
      visibleItems: 0,
      currentX: 0,
      amount: props.shifted,
      childrenWidth: 1,
      // to avoid division by 0
      totalItems: 0,
      selector: null
    };
    // ensure the function is bind to the current object
    cov_1o978z52du().s[47]++;
    _this.previous = _this.previous.bind(_this);
    cov_1o978z52du().s[48]++;
    _this.next = _this.next.bind(_this);
    return _this;
  }
  (0, _inherits2.default)(FilmStrip, _PureComponent);
  return (0, _createClass2.default)(FilmStrip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_1o978z52du().f[26]++;
      cov_1o978z52du().s[49]++;
      window.addEventListener('resize', this.computeWidthAndUpdate.bind(this));
      cov_1o978z52du().s[50]++;
      this.computeWidthAndUpdate();
      cov_1o978z52du().s[51]++;
      this.updateSelector();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps() {
      cov_1o978z52du().f[27]++;
      cov_1o978z52du().s[52]++;
      this.computeWidthAndUpdate();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      cov_1o978z52du().f[28]++;
      cov_1o978z52du().s[53]++;
      if (prevProps.childHeightSelector !== this.props.childHeightSelector) {
        cov_1o978z52du().b[28][0]++;
        cov_1o978z52du().s[54]++;
        this.updateSelector();
      } else {
        cov_1o978z52du().b[28][1]++;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_1o978z52du().f[29]++;
      cov_1o978z52du().s[55]++;
      window.removeEventListener('resize', this.computeWidthAndUpdate.bind(this));
    }
  }, {
    key: "computeWidthAndUpdate",
    value: function computeWidthAndUpdate() {
      var _this2 = this;
      cov_1o978z52du().f[33]++;
      var childrenWidth = (cov_1o978z52du().s[62]++, 1);
      var totalItems = (cov_1o978z52du().s[63]++, _react.default.Children.count(this.props.children));
      cov_1o978z52du().s[64]++;
      (0, _from.default)(new Array(totalItems), function (value, index) {
        cov_1o978z52du().f[34]++;
        var slider = (cov_1o978z52du().s[65]++, _this2["sliderEl".concat(index)]);
        // eslint-disable-next-line
        cov_1o978z52du().s[66]++;
        if ((cov_1o978z52du().b[30][0]++, slider) && (cov_1o978z52du().b[30][1]++, _reactDom.default.findDOMNode(slider))) {
          cov_1o978z52du().b[29][0]++;
          // eslint-disable-next-line
          var sliderEl = (cov_1o978z52du().s[67]++, _reactDom.default.findDOMNode(slider));
          cov_1o978z52du().s[68]++;
          childrenWidth += sliderEl.getBoundingClientRect().width;
        } else {
          cov_1o978z52du().b[29][1]++;
        }
        cov_1o978z52du().s[69]++;
        return value;
      });
      cov_1o978z52du().s[70]++;
      this.setState({
        childrenWidth: childrenWidth,
        totalItems: totalItems
      }, this.update);
    }
  }, {
    key: "update",
    value: function update() {
      var _this3 = this;
      cov_1o978z52du().f[35]++;
      cov_1o978z52du().s[71]++;
      if (this.sc) {
        cov_1o978z52du().b[31][0]++;
        var _ref18 = (cov_1o978z52du().s[72]++, this.state),
          visibleItems = _ref18.visibleItems,
          amount = _ref18.amount,
          totalItems = _ref18.totalItems,
          childrenWidth = _ref18.childrenWidth;
        var updatedVisibleItems = (cov_1o978z52du().s[73]++, Math.round(this.sc.getBoundingClientRect().width * totalItems / childrenWidth));
        cov_1o978z52du().s[74]++;
        if (visibleItems !== updatedVisibleItems) {
          cov_1o978z52du().b[32][0]++;
          cov_1o978z52du().s[75]++;
          this.setState({
            visibleItems: updatedVisibleItems,
            currentX: -100 / updatedVisibleItems * amount
          });
        } else {
          cov_1o978z52du().b[32][1]++;
        }
        cov_1o978z52du().s[76]++;
        if (this.props.accessibilityChildrenSelector) {
          cov_1o978z52du().b[33][0]++;
          cov_1o978z52du().s[77]++;
          var _loop = function _loop(i) {
            var slider = (cov_1o978z52du().s[79]++, _this3["sliderEl".concat(i)]);
            // eslint-disable-next-line
            cov_1o978z52du().s[80]++;
            if ((cov_1o978z52du().b[35][0]++, slider) && (cov_1o978z52du().b[35][1]++, _reactDom.default.findDOMNode(slider))) {
              cov_1o978z52du().b[34][0]++;
              // eslint-disable-next-line
              var sliderEl = (cov_1o978z52du().s[81]++, _reactDom.default.findDOMNode(slider));
              var childEls = (cov_1o978z52du().s[82]++, sliderEl.querySelectorAll(_this3.props.accessibilityChildrenSelector));
              cov_1o978z52du().s[83]++;
              childEls.forEach(function (childEl) {
                cov_1o978z52du().f[36]++;
                cov_1o978z52du().s[84]++;
                if ((cov_1o978z52du().b[37][0]++, childEl) && (cov_1o978z52du().b[37][1]++, i >= amount + updatedVisibleItems)) {
                  cov_1o978z52du().b[36][0]++;
                  var productSelector = (cov_1o978z52du().s[85]++, childEl.querySelector('a'));
                  var productDateSelector = (cov_1o978z52du().s[86]++, childEl.querySelector('.stx-ProductDate'));
                  cov_1o978z52du().s[87]++;
                  if (productSelector) {
                    cov_1o978z52du().b[38][0]++;
                    cov_1o978z52du().s[88]++;
                    productSelector.setAttribute('aria-hidden', 'true');
                    cov_1o978z52du().s[89]++;
                    productSelector.setAttribute('tabIndex', '-1');
                  } else {
                    cov_1o978z52du().b[38][1]++;
                  }
                  cov_1o978z52du().s[90]++;
                  if (productDateSelector) {
                    cov_1o978z52du().b[39][0]++;
                    cov_1o978z52du().s[91]++;
                    childEl.querySelector('.stx-ProductDate').setAttribute('aria-hidden', 'true');
                  } else {
                    cov_1o978z52du().b[39][1]++;
                  }
                } else {
                  cov_1o978z52du().b[36][1]++;
                }
              });
            } else {
              cov_1o978z52du().b[34][1]++;
            }
          };
          // Update accessibility display of not showing items
          for (var i = (cov_1o978z52du().s[78]++, 0); i < totalItems; i += 1) {
            _loop(i);
          }
        } else {
          cov_1o978z52du().b[33][1]++;
        }
      } else {
        cov_1o978z52du().b[31][1]++;
      }
    }
  }, {
    key: "previous",
    value: function previous() {
      cov_1o978z52du().f[37]++;
      var _ref19 = (cov_1o978z52du().s[92]++, this.state),
        visibleItems = _ref19.visibleItems,
        amount = _ref19.amount;
      var newAmount = (cov_1o978z52du().s[93]++, amount - 1 > 0 ? (cov_1o978z52du().b[40][0]++, amount - 1) : (cov_1o978z52du().b[40][1]++, 0));
      cov_1o978z52du().s[94]++;
      if (this.props.accessibilityChildrenSelector) {
        cov_1o978z52du().b[41][0]++;
        cov_1o978z52du().s[95]++;
        this.updateAccessibilityCarousel(newAmount);
      } else {
        cov_1o978z52du().b[41][1]++;
      }
      cov_1o978z52du().s[96]++;
      this.setState({
        amount: newAmount,
        currentX: -100 / visibleItems * newAmount
      }, this.onVisibleElementsChange);
    }
  }, {
    key: "next",
    value: function next() {
      var _this$props$onHideChe, _this$props2;
      cov_1o978z52du().f[38]++;
      var _ref20 = (cov_1o978z52du().s[97]++, this.state),
        visibleItems = _ref20.visibleItems,
        amount = _ref20.amount,
        totalItems = _ref20.totalItems;
      var newAmount = (cov_1o978z52du().s[98]++, amount + 1 < totalItems ? (cov_1o978z52du().b[42][0]++, amount + 1) : (cov_1o978z52du().b[42][1]++, amount));
      cov_1o978z52du().s[99]++;
      if (this.props.accessibilityChildrenSelector) {
        cov_1o978z52du().b[43][0]++;
        cov_1o978z52du().s[100]++;
        this.updateAccessibilityCarousel(newAmount);
      } else {
        cov_1o978z52du().b[43][1]++;
      }
      cov_1o978z52du().s[101]++;
      this.setState({
        amount: newAmount,
        currentX: -100 / visibleItems * newAmount
      }, this.onVisibleElementsChange, (_this$props$onHideChe = (_this$props2 = this.props).onHideChevron) === null || _this$props$onHideChe === void 0 ? void 0 : _this$props$onHideChe.call(_this$props2, visibleItems + newAmount < totalItems));
    }
  }, {
    key: "updateAccessibilityCarousel",
    value: function updateAccessibilityCarousel(curIdx) {
      var _this4 = this;
      cov_1o978z52du().f[39]++;
      var _ref21 = (cov_1o978z52du().s[102]++, this.state),
        visibleItems = _ref21.visibleItems,
        totalItems = _ref21.totalItems;
      cov_1o978z52du().s[103]++;
      var _loop2 = function _loop2(i) {
        var slider = (cov_1o978z52du().s[105]++, _this4["sliderEl".concat(i)]);
        // eslint-disable-next-line
        cov_1o978z52du().s[106]++;
        if ((cov_1o978z52du().b[45][0]++, slider) && (cov_1o978z52du().b[45][1]++, _reactDom.default.findDOMNode(slider))) {
          cov_1o978z52du().b[44][0]++;
          // eslint-disable-next-line
          var sliderEl = (cov_1o978z52du().s[107]++, _reactDom.default.findDOMNode(slider));
          var childEls = (cov_1o978z52du().s[108]++, sliderEl.querySelectorAll(_this4.props.accessibilityChildrenSelector));
          cov_1o978z52du().s[109]++;
          childEls.forEach(function (childEl) {
            cov_1o978z52du().f[40]++;
            var productSelector = (cov_1o978z52du().s[110]++, childEl.querySelector('a'));
            var productDateSelector = (cov_1o978z52du().s[111]++, childEl.querySelector('.stx-ProductDate'));
            cov_1o978z52du().s[112]++;
            if ((cov_1o978z52du().b[47][0]++, i >= curIdx) && (cov_1o978z52du().b[47][1]++, i < curIdx + visibleItems)) {
              cov_1o978z52du().b[46][0]++;
              cov_1o978z52du().s[113]++;
              if (productSelector) {
                cov_1o978z52du().b[48][0]++;
                cov_1o978z52du().s[114]++;
                productSelector.removeAttribute('aria-hidden');
                cov_1o978z52du().s[115]++;
                productSelector.setAttribute('tabIndex', '0');
              } else {
                cov_1o978z52du().b[48][1]++;
              }
              cov_1o978z52du().s[116]++;
              if (productDateSelector) {
                cov_1o978z52du().b[49][0]++;
                cov_1o978z52du().s[117]++;
                childEl.querySelector('.stx-ProductDate').removeAttribute('aria-hidden');
              } else {
                cov_1o978z52du().b[49][1]++;
              }
            } else {
              cov_1o978z52du().b[46][1]++;
              cov_1o978z52du().s[118]++;
              if (productSelector) {
                cov_1o978z52du().b[50][0]++;
                cov_1o978z52du().s[119]++;
                productSelector.setAttribute('aria-hidden', 'true');
                cov_1o978z52du().s[120]++;
                productSelector.setAttribute('tabIndex', '-1');
              } else {
                cov_1o978z52du().b[50][1]++;
              }
              cov_1o978z52du().s[121]++;
              if (productDateSelector) {
                cov_1o978z52du().b[51][0]++;
                cov_1o978z52du().s[122]++;
                childEl.querySelector('.stx-ProductDate').setAttribute('aria-hidden', 'true');
              } else {
                cov_1o978z52du().b[51][1]++;
              }
            }
          });
        } else {
          cov_1o978z52du().b[44][1]++;
        }
      };
      for (var i = (cov_1o978z52du().s[104]++, 0); i < totalItems; i += 1) {
        _loop2(i);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      cov_1o978z52du().f[42]++;
      var _ref22 = (cov_1o978z52du().s[127]++, this.state),
        visibleItems = _ref22.visibleItems,
        currentX = _ref22.currentX,
        amount = _ref22.amount,
        totalItems = _ref22.totalItems,
        selector = _ref22.selector;
      var _ref23 = (cov_1o978z52du().s[128]++, this.props),
        children = _ref23.children,
        iconColor = _ref23.iconColor,
        className = _ref23.className,
        themeContext = _ref23.themeContext,
        itemSpacing = _ref23.itemSpacing,
        desktopSlider = _ref23.desktopSlider;
      var isEvolutionTheme = (cov_1o978z52du().s[129]++, themeContext.theme === _themeProvider.TicketShopTheme.EVOLUTION);
      var showLeftChevron = (cov_1o978z52du().s[130]++, amount > 0);
      var showRightChevron = (cov_1o978z52du().s[131]++, visibleItems + amount < totalItems);
      // by default the selection is done on the height of the wrapper
      cov_1o978z52du().s[132]++;
      return /*#__PURE__*/_react.default.createElement(Wrapper, {
        className: "".concat(className, " ").concat(selector),
        innerRef: function innerRef(wrap) {
          cov_1o978z52du().f[43]++;
          cov_1o978z52du().s[133]++;
          _this5.wrapper = wrap;
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 606,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react.default.createElement(SideChevron, {
        show: showLeftChevron,
        onClick: this.previous,
        onKeyDown: function onKeyDown(e) {
          cov_1o978z52du().f[44]++;
          cov_1o978z52du().s[134]++;
          return (cov_1o978z52du().b[53][0]++, e.key === 'Enter') && (cov_1o978z52du().b[53][1]++, _this5.previous());
        },
        side: "left",
        color: iconColor,
        childHeightSelector: (cov_1o978z52du().b[54][0]++, selector) || (cov_1o978z52du().b[54][1]++, this.wrapper),
        ariaLabel: "Previous product",
        desktopSlider: desktopSlider,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 611,
          columnNumber: 9
        }
      }), /*#__PURE__*/_react.default.createElement(SliderContainer, {
        desktopSlider: desktopSlider,
        isEvolutionTheme: isEvolutionTheme,
        innerRef: function innerRef(sc) {
          cov_1o978z52du().f[45]++;
          cov_1o978z52du().s[135]++;
          _this5.sc = sc;
          cov_1o978z52du().s[136]++;
          return sc;
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 621,
          columnNumber: 9
        }
      }, /*#__PURE__*/_react.default.createElement(Slider, {
        className: (0, _utils.classNames)({
          'mobile-slider': (cov_1o978z52du().b[55][0]++, !((cov_1o978z52du().b[56][0]++, _reactDeviceDetect.isDesktop) || (cov_1o978z52du().b[56][1]++, desktopSlider))) && (cov_1o978z52du().b[55][1]++, isEvolutionTheme) && (cov_1o978z52du().b[55][2]++, totalItems > visibleItems)
        }),
        slide: amount,
        itemSpacing: itemSpacing,
        totalItems: totalItems,
        visibleItems: visibleItems,
        isEvolutionTheme: isEvolutionTheme,
        currentX: currentX,
        desktopSlider: desktopSlider,
        innerRef: function innerRef(s) {
          cov_1o978z52du().f[46]++;
          cov_1o978z52du().s[137]++;
          _this5.s = s;
          cov_1o978z52du().s[138]++;
          return s;
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 628,
          columnNumber: 11
        }
      }, _react.default.Children.map(children, function (element, idx) {
        cov_1o978z52du().f[47]++;
        cov_1o978z52du().s[139]++;
        return /*#__PURE__*/_react.default.cloneElement(element, {
          ref: function ref(node) {
            cov_1o978z52du().f[48]++;
            cov_1o978z52du().s[140]++;
            _this5["sliderEl".concat(idx)] = node;
            cov_1o978z52du().s[141]++;
            return node;
          }
        });
      }))), /*#__PURE__*/_react.default.createElement(SideChevron, {
        desktopSlider: desktopSlider,
        show: showRightChevron,
        onClick: this.next,
        onKeyDown: function onKeyDown(e) {
          cov_1o978z52du().f[49]++;
          cov_1o978z52du().s[142]++;
          return (cov_1o978z52du().b[57][0]++, e.key === 'Enter') && (cov_1o978z52du().b[57][1]++, _this5.next());
        },
        side: "right",
        childHeightSelector: (cov_1o978z52du().b[58][0]++, selector) || (cov_1o978z52du().b[58][1]++, this.wrapper),
        ariaLabel: "Next product",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 654,
          columnNumber: 9
        }
      }));
    }
  }]);
}(_react.PureComponent);
(0, _defineProperty2.default)(FilmStrip, "propTypes", (cov_1o978z52du().s[43]++, {
  /** The list of object in the Film strip, better if they are the  */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,
  /** The background color of the button to go left or right */
  iconBackgroundColor: _propTypes.default.string,
  /** The icon color of the button to go left or right */
  iconColor: _propTypes.default.string,
  /** The child selector for the height computation of the left/right chevron. (to center vertically) */
  childHeightSelector: _propTypes.default.string,
  /** Additional class for the filmstrip component. Is used for the chevrons alignement */
  className: _propTypes.default.string,
  /** Number to indicate the number of Columns to be shifted by default */
  shifted: _propTypes.default.number,
  /** Value of children elements selector that use to add/remove accessibility values */
  accessibilityChildrenSelector: _propTypes.default.string,
  /** theme context */
  themeContext: _themeProvider.ThemeContextType,
  itemSpacing: _propTypes.default.number,
  /** event */
  onChange: _propTypes.default.func,
  /** display as desktop */
  desktopSlider: _propTypes.default.bool,
  /** event */
  onHideChevron: _propTypes.default.func
}));
(0, _defineProperty2.default)(FilmStrip, "defaultProps", (cov_1o978z52du().s[44]++, {
  iconBackgroundColor: '',
  iconColor: undefined,
  childHeightSelector: '',
  className: '',
  shifted: 0,
  accessibilityChildrenSelector: '',
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT,
  itemSpacing: 0,
  onChange: null,
  desktopSlider: false,
  onHideChevron: null
}));
var _default = exports.default = (0, _themeProvider.withThemeConsumer)(FilmStrip);